import {
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  shiftLeft3tsh2sstjchzn as shiftLeft,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { asIterable3syp9x858o4em as asIterable } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function containsCode($this, code) {
  if (!((code >>> 7 | 0) === 0))
    return false;
  var bits = code < 64 ? $this.h4x_1 : $this.i4x_1;
  return (shiftRightUnsigned(bits, code) & 1n) === 1n;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      j4x(chars) {
        var low = 0n;
        var high = 0n;
        var _iterator__ex2g4s = chars.p1();
        while (_iterator__ex2g4s.q1()) {
          var char = _iterator__ex2g4s.r1().f4_1;
          // Inline function 'kotlin.code' call
          var code = Char__toInt_impl_vasixd(char);
          // Inline function 'kotlin.require' call
          if (!(code < 128)) {
            var message = "Only ASCII characters are supported, got '" + toString(char) + "' (code " + code + ')';
            throw IllegalArgumentException().o2(toString_0(message));
          }
          if (code < 64)
            low = low | shiftLeft(1n, code);
          else
            high = high | shiftLeft(1n, code);
        }
        return new (AsciiBitSet())(low, high);
      }
      k3o(chars) {
        return this.j4x(asIterable(chars));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AsciiBitSetClass;
function AsciiBitSet() {
  if (AsciiBitSetClass === VOID) {
    class $ {
      constructor(low, high) {
        this.h4x_1 = low;
        this.i4x_1 = high;
      }
      xp(char) {
        // Inline function 'kotlin.code' call
        var tmp$ret$0 = Char__toInt_impl_vasixd(char);
        return containsCode(this, tmp$ret$0);
      }
      k4x(byte) {
        return containsCode(this, byte);
      }
      l4x(other) {
        return new (AsciiBitSet())(this.h4x_1 | other.h4x_1, this.i4x_1 | other.i4x_1);
      }
    }
    initMetadataForClass($, 'AsciiBitSet');
    AsciiBitSetClass = $;
  }
  return AsciiBitSetClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance2wec3srl1ini,
};
//endregion

//# sourceMappingURL=AsciiBitSet.mjs.map
